import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, User, Trash2, Shield } from 'lucide-react';
import { supabase } from '../supabase';
type Konseling = {
  id: string;
  nama: string;
  kelas: string;
  no_hp: string;
  keluhan: string;
  jenis_konseling: string;
  jadwal: string;
  created_at: string;
};
export function KonselingBooking() {
  const [data, setData] = useState<Konseling[]>([]);
  const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    setLoading(true);
    const {
      data: userData
    } = await supabase.auth.getUser();
    const user = userData.user;
    if (!user) {
      setLoading(false);
      return;
    }
    const {
      data,
      error
    } = await supabase.from('konseling_bookings').select('*').eq('user_id', user.id).order('created_at', {
      ascending: false
    });
    if (!error && data) {
      setData(data);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  const handleDelete = async (id: string) => {
    const confirmDelete = window.confirm('Yakin ingin menghapus pengajuan konseling ini?');
    if (!confirmDelete) return;
    const {
      error
    } = await supabase.from('konseling_bookings').delete().eq('id', id);
    if (error) {
      alert('Gagal menghapus data');
      return;
    }
    setData(prev => prev.filter(item => item.id !== id));
  };
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString('id-ID', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Jakarta'
    });
  };
  return <div className="min-h-screen bg-white py-10 px-4" data-id="element-398">
      <div className="max-w-5xl mx-auto" data-id="element-399">

        <div className="text-center mb-10" data-id="element-400">
          <h1 className="text-3xl font-bold text-dark" data-id="element-401">
            Riwayat Konseling
          </h1>

          <p className="text-gray-500 text-sm mt-2" data-id="element-402">
            Semua pengajuan konseling yang pernah kamu buat
          </p>
        </div>

        {loading && <div className="text-center text-gray-500" data-id="element-403">
            Loading data...
          </div>}

        {!loading && data.length === 0 && <div className="bg-gray-50 rounded-2xl p-10 text-center text-gray-500" data-id="element-404">
            Belum ada riwayat konseling
          </div>}

        <div className="space-y-4" data-id="element-405">
          {data.map(item => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-white border rounded-2xl p-5 shadow-sm" data-id="element-406">
              <div className="flex justify-between items-start" data-id="element-407">

                <div className="flex gap-3" data-id="element-408">
                  <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center" data-id="element-409">
                    <User size={18} className="text-blue-600" data-id="element-410" />
                  </div>

                  <div data-id="element-411">
                    <h3 className="font-semibold" data-id="element-412">
                      {item.nama}
                    </h3>

                    <p className="text-xs text-gray-500" data-id="element-413">
                      {item.kelas} • {item.no_hp}
                    </p>
                  </div>
                </div>

                <button onClick={() => handleDelete(item.id)} className="text-red-500 hover:bg-red-50 p-2 rounded-lg" data-id="element-414">
                  <Trash2 size={16} data-id="element-415" />
                </button>
              </div>

              <div className="mt-4" data-id="element-416">
                <span className="inline-block px-3 py-1 rounded-full text-xs bg-blue-100 text-blue-700" data-id="element-417">
                  {item.jenis_konseling}
                </span>
              </div>

              <p className="mt-3 text-sm text-gray-700" data-id="element-418">
                {item.keluhan}
              </p>

              <div className="mt-4 space-y-1 text-xs text-gray-500" data-id="element-419">

                <div className="flex items-center gap-2" data-id="element-420">
                  <Calendar size={12} data-id="element-421" />
                  Jadwal: {formatDate(item.jadwal)}
                </div>

                <div className="flex items-center gap-2" data-id="element-422">
                  <Clock size={12} data-id="element-423" />
                  Dibuat: {formatDate(item.created_at)}
                </div>

              </div>
            </motion.div>)}
        </div>

      </div>
    </div>;
}